module.exports = __webpack_public_path__ + "static/media/Buyer-lawyer-landing-page.af76ad22.png";